// Video Persona Tracking Utilities
// Tracks video views and watch duration for analytics

interface VideoView {
  name: string;
  views: number;
  totalDuration: number; // in seconds
}

// Track a video view with duration
export const trackVideoView = (videoName: string, durationSeconds: number) => {
  try {
    const stored = localStorage.getItem('videoPersonaViews');
    const videoViews: VideoView[] = stored ? JSON.parse(stored) : [];
    
    // Find existing video or create new entry
    const existingIndex = videoViews.findIndex(v => v.name === videoName);
    
    if (existingIndex >= 0) {
      videoViews[existingIndex].views += 1;
      videoViews[existingIndex].totalDuration += durationSeconds;
    } else {
      videoViews.push({
        name: videoName,
        views: 1,
        totalDuration: durationSeconds
      });
    }
    
    localStorage.setItem('videoPersonaViews', JSON.stringify(videoViews));
  } catch (error) {
    console.error('Error tracking video view:', error);
  }
};

// Track agent connection
export const trackAgentConnection = (agentName: string, isConnected: boolean) => {
  try {
    const stored = localStorage.getItem('agentConnections');
    let connections = stored ? JSON.parse(stored) : { totalConnected: 0, activeAgents: [] };
    
    if (isConnected) {
      // Add agent if not already in list
      if (!connections.activeAgents.includes(agentName)) {
        connections.activeAgents.push(agentName);
        connections.totalConnected = connections.activeAgents.length;
      }
    } else {
      // Remove agent from list
      connections.activeAgents = connections.activeAgents.filter((name: string) => name !== agentName);
      connections.totalConnected = connections.activeAgents.length;
    }
    
    localStorage.setItem('agentConnections', JSON.stringify(connections));
  } catch (error) {
    console.error('Error tracking agent connection:', error);
  }
};

// Track configured context usage
export const trackConfiguredContext = (contextType: 'library' | 'video' | 'news' | 'aiTrends') => {
  try {
    const stored = localStorage.getItem('configuredContextUsage');
    let contexts = stored ? JSON.parse(stored) : { library: 0, video: 0, news: 0, aiTrends: 0 };
    
    contexts[contextType] = (contexts[contextType] || 0) + 1;
    
    localStorage.setItem('configuredContextUsage', JSON.stringify(contexts));
  } catch (error) {
    console.error('Error tracking configured context:', error);
  }
};
